import { useUnreads } from "@talkjs/react";

export function useChatUnreadCount() {
  const unreads = useUnreads();

  return (
    unreads?.reduce((sum, item) => sum + (item.unreadMessageCount || 0), 0) || 0
  );
}

export default useChatUnreadCount;
